import { render, staticRenderFns } from "./TeamTopicModal.vue?vue&type=template&id=f64a83b8&scoped=true&"
import script from "./TeamTopicModal.vue?vue&type=script&lang=js&"
export * from "./TeamTopicModal.vue?vue&type=script&lang=js&"
import style0 from "./TeamTopicModal.vue?vue&type=style&index=0&id=f64a83b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64a83b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f64a83b8')) {
      api.createRecord('f64a83b8', component.options)
    } else {
      api.reload('f64a83b8', component.options)
    }
    module.hot.accept("./TeamTopicModal.vue?vue&type=template&id=f64a83b8&scoped=true&", function () {
      api.rerender('f64a83b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/modal/AiAssistantDrawer/TeamTopicModal.vue"
export default component.exports